function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import React from "react";
import { variables as breakpoints } from "@xo-union/tk-ui-breakpoints";
import { descendingOrderViewportCompare, descendingOrderPixelDensityCompare } from "../compareFunctions/index.js";
import isSourceNode from "../isSourceNode/index.js";
import createMediaQuery from "../createMediaQuery.js";
var units = {
  px: function px(num) {
    return "".concat(num, "px");
  },
  dpi: function dpi(num) {
    return "".concat(num, "dpi");
  }
};
var dpiForPixelDensity = function dpiForPixelDensity(pixelRatio) {
  return pixelRatio * 96;
};
var getNextLargest = function getNextLargest(descendingOrderSortedList, target) {
  var targetIndex = _indexOfInstanceProperty(descendingOrderSortedList).call(descendingOrderSortedList, target) - 1;
  return descendingOrderSortedList[targetIndex];
};
/**
 * Utility processes props and returns utility functions used to create a mutually
 * exclusive set of media queries for a given source
 */
export var mutexMediaQueryFactory = function mutexMediaQueryFactory(props) {
  var _context, _context2, _context3;
  var givenPixelDensities = new _Set(props.pixelDensities);
  var givenViewports = new _Set();
  _forEachInstanceProperty(_context = React.Children).call(_context, props.children, function (child) {
    if (isSourceNode(child)) {
      if (child.props.pixelDensity) {
        givenPixelDensities.add(child.props.pixelDensity);
      }
      givenViewports.add(child.props.viewport);
    }
  });
  if (props.preload && !givenViewports.has('xs')) {
    // eslint-disable-next-line no-console
    console.warn('[@xo-union/tk-component-picture]: Preload is enabled yet there is no source with a `viewport="xs"`. This will cause the browser to fallback to the `img` element, which is not preloaded. Please specify a Source with a `viewport="xs"`');
  }
  var descendingOrderSortedViewports = _sortInstanceProperty(_context2 = _Array$from(givenViewports)).call(_context2, descendingOrderViewportCompare);
  var descendingOrderSortedPixelDensities = _sortInstanceProperty(_context3 = _Array$from(givenPixelDensities)).call(_context3, descendingOrderPixelDensityCompare);
  var getMaxPixelDensity = function getMaxPixelDensity(pixelDensity) {
    return getNextLargest(descendingOrderSortedPixelDensities, pixelDensity);
  };
  var getMaxViewport = function getMaxViewport(viewport) {
    return getNextLargest(descendingOrderSortedViewports, viewport);
  };
  var getWidthBoundaries = function getWidthBoundaries(viewport) {
    var maxViewport = getMaxViewport(viewport);
    var minWidth = units.px(breakpoints.ranges[viewport].min);
    var maxWidth = maxViewport && units.px(breakpoints.ranges[maxViewport].min - 0.02);
    return {
      minWidth: minWidth,
      maxWidth: maxWidth
    };
  };
  var getResolutionBoundaries = function getResolutionBoundaries(pixelDensity) {
    var maxPixelDensity = getMaxPixelDensity(pixelDensity);
    var minResolution = units.dpi(dpiForPixelDensity(pixelDensity));
    var maxResolution = maxPixelDensity && units.dpi(dpiForPixelDensity(maxPixelDensity) - 1);
    return {
      minPixelDensity: pixelDensity,
      maxPixelDensity: maxPixelDensity - 0.1,
      minResolution: minResolution,
      maxResolution: maxResolution
    };
  };
  var createMutexMediaQuery = function createMutexMediaQuery(_ref) {
    var pixelDensity = _ref.pixelDensity,
      viewport = _ref.viewport;
    return createMediaQuery(_objectSpread(_objectSpread({}, getWidthBoundaries(viewport)), getResolutionBoundaries(pixelDensity)));
  };
  return createMutexMediaQuery;
};
export var createNonExclusiveMediaQuery = function createNonExclusiveMediaQuery(_ref2) {
  var pixelDensity = _ref2.pixelDensity,
    viewport = _ref2.viewport;
  var minWidth = units.px(breakpoints.ranges[viewport].min);
  var minResolution = pixelDensity && units.dpi(dpiForPixelDensity(pixelDensity));
  var minPixelDensity = pixelDensity;
  return createMediaQuery({
    minWidth: minWidth,
    minResolution: minResolution,
    minPixelDensity: minPixelDensity
  });
};